import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import { clamp, restProps } from '../utils';

import PageLinks from './PageLinks';
import Pager from './Pager';
import styles from './Bar.less';

const cx = classnames.bind(styles);

/**
 * **Access:**
 * ```js
 * import { Pagination } from '@iss/client-react-components'
 * ...
 * render () {
 * 	return <Pagination.Bar .../>
 * }
 * ```
 * A common pager bar. Supports direct access and next/previous.
 */
export default class Bar extends React.Component {
  static propTypes = {
    /** The number of items per page */
    pageSize: PropTypes.number.isRequired,
    /** The total number of items */
    totalCount: PropTypes.number.isRequired,
    /** The current page number (not the index, this is 1 based) */
    currentPage: PropTypes.number.isRequired,
    /** A function to produce a route or link target (href) for any given page. */
    pageLinkFactory: PropTypes.func,
    /** A callback to handle page transitions (if not routing) */
    onPageChange: PropTypes.func,
  };

  render() {
    const { className, pageSize, totalCount, ...props } = this.props;

    const pageCount = clamp(Math.ceil(totalCount / pageSize));
    const largePageCount = pageCount > 10;

    return (
      <div className={cx('pagination', { labeled: largePageCount }, className)} {...restProps(Bar, props)}>
        <PageLinks
          {...this.props}
          pageCount={pageCount}
          type={largePageCount ? PageLinks.Style.LABELED : PageLinks.Style.DOTS}
        />
        <Pager {...this.props} className={cx('pager')} pageCount={pageCount} omitLinks={largePageCount} />
      </div>
    );
  }
}
